<template>
  <div class="col-12 col-lg-6">
    <div class="tit text-center">
      <h1>Documento de identidade</h1>
      <p>Envie uma cópia de um dos documentos de identidade <strong>(RG ou CNH)</strong></p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form>
          <div class="form-group">
            <files-input :files="arquivos" :accept="formatosAceitos"
              :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary" @click="onSubmit">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    const pessoal = this.currentUser.Pessoal
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivosIdentidade || [null]
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    removeFile(index) {
      this.arquivos.splice(index, 1)
    },
    clearFile(index) {
      this.$set(this.arquivos, index, null)
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio do documento de identidade é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()

      if(validation.isValid) {
        
        this.currentUser.Pessoal.ArquivosIdentidade = this.arquivosRecebidos
        
        this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/IdentificationDocumentStep.vue